import { defineAsyncComponent } from 'vue';
import iconoItinerario from '@/assets/icons/builder/itinerario.svg';
import iconoArtistas from '@/assets/icons/builder/musica.svg';
import iconoAsistentes from '@/assets/icons/builder/assistants.svg';
import iconoContacto from '@/assets/icons/builder/contacto.svg';
import iconoFormulario from '@/assets/icons/builder/formulario.svg';
import iconoImagenes from '@/assets/icons/builder/imagenes.svg';
import iconoImagenesYTexto from '@/assets/icons/builder/imagenes-texto.svg';
import iconoVideo from '@/assets/icons/builder/video.svg';
import iconoPatrocinadores from '@/assets/icons/builder/patrocinadores.svg';
import iconoPreguntasFrecuentes from '@/assets/icons/builder/preguntasFrecuentes.svg';
import iconoTexto from '@/assets/icons/builder/texto.svg';
import iconoAdjuntos from '@/assets/icons/builder/archivosAdjuntos.svg';
import iconoAlojamientos from '@/assets/icons/builder/alojamientos.svg';
import iconoRedesSociales from '@/assets/icons/builder/redes-sociales.svg';
import iconoCalendario from '@/assets/icons/builder/calendar.svg';
import iconoCuentaAtras from '@/assets/icons/builder/cuenta-atras.svg';
import iconoUbicaciones from '@/assets/icons/builder/location.svg';
import iconoDatosBasicos from '@/assets/icons/builder/datosbasicos.svg';
import iconoExperiencias from '@/assets/icons/builder/experiencias.svg';
import iconoServicios from '@/assets/icons/builder/servicios.svg';
import iconoPagos from '@/assets/icons/builder/pagosyplazos.svg';
import iconoTerminos from '@/assets/icons/builder/terminosycondiciones.svg';
import { useI18n } from 'vue-i18n';

export const DESIGN_A = 'DESIGN_A';
export const DESIGN_B = 'DESIGN_B';

export const DISPOSITIVO = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
};

export const ENTITY_TYPES = {
  VIAJE: 'viaje',
  AGRUPACION: 'agrupacion',
};

export const BLOCK_TYPES = {
  SUMMARY: 'summary',
  EXPERIENCES: 'experiences',
  SERVICES: 'services',
  PAYMENTS: 'payments',
  TERMS: 'termsAndConditions',
  TEXT: 'text',
  ITINERARY: 'itinerary',
  IMAGES: 'images',
  VIDEO: 'video',
  IMAGES_AND_TEXT: 'imagesAndText',
  FILES: 'files',
  SPONSORS: 'sponsors',
  ACCOMMODATIONS: 'accommodations',
  ARTISTS: 'artists',
  CONTACT: 'contact',
  SOCIAL_MEDIA: 'socialMedia',
  INDEX: 'index',
  ATTENDEES: 'attendees',
  FORM: 'form',
  LOCATIONS: 'locations',
  FAQS: 'faqs',
  CALENDAR: 'calendar',
  COUNTDOWN: 'countdown',
};

export function getIconBlock(builderType) {
  const blockTypeToIcon = {
    [BLOCK_TYPES.FILES]: iconoAdjuntos,
    [BLOCK_TYPES.ARTISTS]: iconoArtistas,
    [BLOCK_TYPES.ATTENDEES]: iconoAsistentes,
    [BLOCK_TYPES.CONTACT]: iconoContacto,
    [BLOCK_TYPES.FORM]: iconoFormulario,
    [BLOCK_TYPES.ITINERARY]: iconoItinerario,
    [BLOCK_TYPES.IMAGES]: iconoImagenes,
    [BLOCK_TYPES.IMAGES_AND_TEXT]: iconoImagenesYTexto,
    [BLOCK_TYPES.LOCATIONS]: iconoUbicaciones,
    [BLOCK_TYPES.VIDEO]: iconoVideo,
    [BLOCK_TYPES.SPONSORS]: iconoPatrocinadores,
    [BLOCK_TYPES.ACCOMMODATIONS]: iconoAlojamientos,
    [BLOCK_TYPES.TEXT]: iconoTexto,
    [BLOCK_TYPES.FAQS]: iconoPreguntasFrecuentes,
    [BLOCK_TYPES.SOCIAL_MEDIA]: iconoRedesSociales,
    [BLOCK_TYPES.CALENDAR]: iconoCalendario,
    [BLOCK_TYPES.COUNTDOWN]: iconoCuentaAtras,
    [BLOCK_TYPES.SUMMARY]: iconoDatosBasicos,
    [BLOCK_TYPES.EXPERIENCES]: iconoExperiencias,
    [BLOCK_TYPES.SERVICES]: iconoServicios,
    [BLOCK_TYPES.PAYMENTS]: iconoPagos,
    [BLOCK_TYPES.TERMS]: iconoTerminos,
  };

  return blockTypeToIcon[builderType] || iconoTexto;
}

export function getNombreBlock(builder) {
  const { t } = useI18n();
  const defaultBlocks = [
    BLOCK_TYPES.SUMMARY,
    BLOCK_TYPES.EXPERIENCES,
    BLOCK_TYPES.SERVICES,
    BLOCK_TYPES.PAYMENTS,
    BLOCK_TYPES.TERMS,
  ];

  if (defaultBlocks.includes(builder.tipo)) {
    return t(`builder.title.${builder.tipo}`);
  }
  return builder.nombre;
}

export function getBlockComponent(tipo, dispositivo = DISPOSITIVO.DESKTOP, entityType = ENTITY_TYPES.VIAJE) {
  const blockComponents = {
    [BLOCK_TYPES.SUMMARY]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/SummaryViajeBlockDesktop.vue'),
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/SummaryAgrupacionBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/SummaryViajeBlockMobile.vue'),
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/SummaryAgrupacionBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.EXPERIENCES]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/ExperiencesAgrupacionBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.AGRUPACION]: () =>
          import('@/views/productos/informacion/builder/ExperiencesAgrupacionBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.SERVICES]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/ServicesBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/ServicesBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.TEXT]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/TextBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/TextBlockMobile.vue'),
    },
    [BLOCK_TYPES.ITINERARY]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ItineraryBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ItineraryBlockMobile.vue'),
    },
    [BLOCK_TYPES.VIDEO]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/VideoBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/VideoBlockMobile.vue'),
    },
    [BLOCK_TYPES.IMAGES]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ImagesBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ImagesBlockMobile.vue'),
    },
    [BLOCK_TYPES.TERMS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/TermsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/TermsBlockMobile.vue'),
    },
    [BLOCK_TYPES.PAYMENTS]: {
      [DISPOSITIVO.DESKTOP]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/PaymentsBlockDesktop.vue'),
      },
      [DISPOSITIVO.MOBILE]: {
        [ENTITY_TYPES.VIAJE]: () => import('@/views/productos/informacion/builder/PaymentsBlockMobile.vue'),
      },
    },
    [BLOCK_TYPES.IMAGES_AND_TEXT]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ImagesAndTextDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ImagesAndTextMobile.vue'),
    },
    [BLOCK_TYPES.SPONSORS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/SponsorsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/SponsorsBlockMobile.vue'),
    },
    [BLOCK_TYPES.FILES]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/FilesBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/FilesBlockMobile.vue'),
    },
    [BLOCK_TYPES.ACCOMMODATIONS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/AccommodationsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/AccommodationsBlockMobile.vue'),
    },
    [BLOCK_TYPES.ARTISTS]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ArtistsBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ArtistsBlockMobile.vue'),
    },
    [BLOCK_TYPES.CONTACT]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/ContactBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/ContactBlockMobile.vue'),
    },
    [BLOCK_TYPES.SOCIAL_MEDIA]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/SocialMediaBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/SocialMediaBlockMobile.vue'),
    },
    [BLOCK_TYPES.INDEX]: {
      [DISPOSITIVO.DESKTOP]: () => import('@/views/productos/informacion/builder/IndexBlockDesktop.vue'),
      [DISPOSITIVO.MOBILE]: () => import('@/views/productos/informacion/builder/IndexBlockMobile.vue'),
    },
  };

  const componentConfig = blockComponents[tipo];
  if (!componentConfig) return null;

  const deviceConfig = componentConfig[dispositivo];
  if (!deviceConfig) return null;

  const component = typeof deviceConfig === 'object' ? deviceConfig[entityType] : deviceConfig;
  return component ? defineAsyncComponent(component) : null;
}

export function sortBlocksByOrder(blocks) {
  const visibleBlocks = blocks.filter(block => block.visible === true);
  return visibleBlocks.sort((a, b) => a.order - b.order);
}
